import { resizeNavMobile } from './_nav-mobile.js';
import { handleTicker } from './_ticker.js';
// import { handleCarousel } from './_carousel-news-events.js';

window.addEventListener("orientationchange", function () {
  this.setTimeout(() => {
    resizeNavMobile();
    // handleCarousel();
    handleTicker();
  }, 300);
}, false);
